import { useEffect } from "react";

export const useDevModeLoginSetup = (
  registerDevAction,
  clearDevActions,
  setEmail,
  setPendingUser,
  setLoginSuccess,
  setShow2FA
) => {
  useEffect(() => {
    registerDevAction({
      label: "Skip to 2FA",
      onClick: () => {
        const dummyUser = {
          id: "dev_123",
          user_id: "dev_user",
          company_name: "Dev Company Inc.",
          email: "dev@devcompany.com",
          phone_number: "+1 (555) 123-4567",
          city: "San Francisco",
          address: "123 Dev Street, Suite 100",
          lat: "37.7749",
          lon: "-122.4194",
          ghg_rating: 4.2,
          is_active: 1,
        };

        setEmail("dev@devcompany.com");
        setPendingUser(dummyUser);

        localStorage.setItem("dev_profile", JSON.stringify(dummyUser));
        localStorage.setItem("access_token", "dev_token");
        localStorage.setItem("refresh_token", "dev_refresh_token");
        localStorage.setItem("active_user_id", "dev_123");

        setLoginSuccess(true);
        setShow2FA(true);
      },
    });

    return () => {
      clearDevActions();
    };
  }, [
    registerDevAction,
    clearDevActions,
    setEmail,
    setPendingUser,
    setLoginSuccess,
    setShow2FA,
  ]);
};
